import React from "react";
import "./Bonus.scss";
import { setItem } from "../../util/util";
import http from "../../util/api";
import {Toast, Icon, SearchBar } from "antd-mobile";
import qs from "qs";
import Loading from "../../components/Loading";
const mapping=[
  {
    eventId:'685108179250',
    rankResid:'685990220046',
    bonusResid:'685116756229'
  }
]
class Bonus extends React.Component {
  state = {
    loading:false,
    userData:{
    },
    bonusData:{
    },
    bounsDetails:[
    ],
    bonusResid:'',
    pageIndex:0
  };
  async componentDidMount() {
    let token=localStorage.getItem('AccessToken');
    if(token){
   this.getData();
    }else{
      this.props.history.push('/login')

  }
  }
   //手接触屏幕
   handleTouchStart = (e) => {
   }
  //手在屏幕上移动
  handleTouchMove = (e) => {
  };
  //手离开屏幕
  handleTouchEnd = (e) => {
    let t = document.getElementById('cal').scrollTop;
    let h = document.getElementById('cal').scrollHeight;
    let o = document.getElementById('cal').clientHeight;
    if(h==t+o){
      this.getNewPage(this.state.pageIndex);
    }
  };
  getData=async()=>{
    const search = document.location.search;
    const querystring = search.substring(1);
    const { eventId } = qs.parse(querystring);
    let rankResid='';
    let bonusResid='';
    if(!eventId){
      Toast.fail('未能获取到活动');
      return false;
    }else{
      let n =0;
      while(n<mapping.length){
        if(mapping[n].eventId==eventId){
          rankResid=mapping[n].rankResid;
          bonusResid=mapping[n].bonusResid;
          this.setState({bonusResid});
        }
        n++;
      }
    }
    this.setState({loading:true});
    try{
      let res = await http().getRecordAndSubTables({
        resid:685988118358,
        subresid:rankResid,
        getsubresource: 1
      });
      let res2 = await http().getTable({
        resid:bonusResid,
        pageSize:10,
        pageIndex:0
      })
      if(res2.data.data.length>0){
        this.setState({bounsDetails:res2.data.data});
      }
      console.log(res)
      if(res.data.data.length>0){
        this.setState({userData:res.data.data[0]});
        
        if(res.data.data[0][rankResid].length>0){
          this.setState({bonusData:res.data.data[0][rankResid][0]});
        }
      }else{
        Toast.fail('未找到用户');
      }
      this.setState({loading:false});

    }catch(e){
      console.error(e);
      if(e.message=='loginerror'){
        this.props.history.push('/login');
      }
      Toast.fail(e.message);
      this.setState({loading:false});
    }
  }
  getNewPage=async(pageIndex)=>{
    this.setState({loading:true});
    let _page=pageIndex;
        _page++;
    console.log(pageIndex)
    try{
      let res = await http().getTable({
        resid:this.state.bonusResid,
        pageSize:10,
        pageIndex:_page
      })
      let arr =this.state.bounsDetails;
      arr=arr.concat(res.data.data);
      this.setState({bounsDetails:arr});
      if(res.data.data.length==0){
        Toast.fail('没有更多数据了',1);
      }else{
        this.setState({pageIndex:_page});
      }
    this.setState({loading:false});

    }catch(e){
      console.error(e);
      Toast.fail(e.message);
      this.setState({loading:false});
    }
  }
  render() {
    return (
      <div className="bonusList">
        {this.state.loading?<Loading/>:null}
       <div className='header'>
         <div className='logo' onClick={()=>{
                    this.props.history.push('/');
                  }}>主页</div>
         <div className='avatar'  onClick={()=>{
                    this.props.history.push('/user');
                  }}
                  style={this.state.userData.imgUrl?{backgroundImage:'url('+this.state.userData.imgUrl+')',backgroundPosition:'center',backgroundRepeat:'no-repeat',backgroundSize:'contain'}:{}}
                  ></div>
                  <div className='userName'
         onClick={()=>{
          this.props.history.push('/user');
        }}
        >
          {this.state.userData.memberName}
        </div>
        </div>
        <div className='container'>
              <h3>
                积分详情
              </h3>
              <div className='total'>
                  <i  onClick={
                    ()=>{
                      this.props.history.push(this.state.bonusData.eventRoute)
                    }
                  } style={{backgroundImage:'url('+this.state.bonusData.eventIcon+')',backgroundSize:'contain',backgroundPosition:'center',backgroundRepeat:'no-repeat'}}></i>
                  <span
                  onClick={
                    ()=>{
                      this.props.history.push(this.state.bonusData.eventRoute)
                    }
                  }
                  >{this.state.bonusData.eventName}</span>
                  <span>可用：{this.state.bonusData.bonus}</span>
              </div>
              <ul 
               onTouchStart={this.handleTouchStart}
               onTouchMove={this.handleTouchMove}
               onTouchEnd={this.handleTouchEnd}
               id='cal'
              >
               {this.state.bounsDetails.length==0?'无记录':null}
                {
                  this.state.bounsDetails.map(
                    (item,key)=>{
                      return(
                        <li key={key}>
                          <div>
                            <span>{item.creatTime}</span>
                            <span>{item.symbol=='加'?'+':'-'}{item.tradeValue}</span>
                          </div>
                          <div>
                            <span>{item.creatReason}</span>
                            <span
                            style={!item.activated?{color:'#843737'}:{}}
                            >{item.symbol=='减'?(item.activated=='Y'?'已审核':'待审核'):''}</span>
                          </div>
                        </li>
                      )
                    }
                  )
                }
              </ul>
        </div>
        <div className='mainBtn' onClick={()=>{
                    this.props.history.push('/bonusApp?eventId='+this.state.bonusData.eventRecid);
                  }}>
          前往兑换积分
        </div>
      </div>
    );
  }
}

export default Bonus;
